(function () {
  function initOtherProducts(root) {
    if (!root || typeof Swiper === 'undefined') return;

    var swiperElement = root.querySelector('.wasui-other-products__swiper');
    if (!swiperElement || swiperElement.dataset.wasuiSwiperReady === 'true') return;

    swiperElement.dataset.wasuiSwiperReady = 'true';

    new Swiper(swiperElement, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      freeMode: true,
      grabCursor: true,
      speed: 500,
      breakpoints: {
        990: {
          freeMode: false
        }
      }
    });
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-wasui-other-products-slider]').forEach(function (root) {
      initOtherProducts(root);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
